(ns minorodata.vcs.model
  (:require [mold.core :as m :include-macros true]))

(declare ->vcs-config ->vcs-repo ->vcs-user-link)

(m/defmodel vcs-config
  {:repo-id    [::m/string "Repository ID"]
   :branch     [::m/string "Branch name"]
   :sync-mode  [::m/string ::m/nilable "outbound | inbound | nil"]
   :provider   [::m/string "VCS provider (e.g. github, azure)"]
   :org        [::m/string "Azure DevOps organisation name"]
   :project    [::m/string "Azure DevOps project name"]
   :project-id [::m/string "Azure DevOps project GUID"]}
  {:singleton true})

(m/defmodel vcs-repo
  {:repo-id    [::m/string ::m/identity "Repository ID"]
   :full-name  [::m/string "Full repository name (e.g. owner/repo)"]
   :name       [::m/string "Repository name"]
   :url        [::m/string "Repository URL"]
   :updated-at [::m/string "Last updated timestamp"]
   :archived   [::m/bool "Whether the repository is archived"]
   :org        [::m/string "Azure DevOps organisation name"]
   :project    [::m/string "Azure DevOps project name"]
   :project-id [::m/string "Azure DevOps project GUID"]})

;; Self-scoped GitHub identity link status for the logged-in user.
;; Mirrors the vcs-config singleton: defmodel auto-generates ->vcs-user-link,
;; the :vcs-user-link/pull sub and the :vcs-user-link/{add,update,delete} events.
(m/defmodel vcs-user-link
  {:github-enabled [::m/bool "Whether GitHub user-linking is enabled for this app"]
   :connected      [::m/bool "Whether the current user has linked their GitHub identity"]
   :login          [::m/string ::m/nilable "GitHub login of the linked user"]
   :provider       [::m/string ::m/nilable "VCS provider (e.g. github)"]}
  {:singleton true})
